import { useEffect, useRef } from 'react'

export const useTutorialVideo = (activeIndex: number) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    video.load()
    void video.play().catch(() => {
      // Browsers can block autoplay until the user interacts with the page.
    })
  }, [activeIndex])

  return videoRef
}
